import { render, staticRenderFns } from "./CUserSettings.vue?vue&type=template&id=bb6c8578&scoped=true&"
import script from "./CUserSettings.vue?vue&type=script&lang=js&"
export * from "./CUserSettings.vue?vue&type=script&lang=js&"
import style0 from "./CUserSettings.vue?vue&type=style&index=0&id=bb6c8578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6c8578",
  null
  
)

export default component.exports